export default __webpack_public_path__ + "static/media/mir.aa52ceec.svg";